import { FormItemController } from "./FormItemController";
import { MultiText } from "../../HTML/Form/Item/MultiText";
import { EditorMultiText } from "../../HTML/Editor/MultiText";
import { toMap } from "../../../../HA";

export class MultiTextController extends FormItemController {

    public getValue() {
        return this.getTag().getSelected();
    }

    public isInputItem() {
        return true;
    }

    protected createItem() {
        const data = toMap({tag: this.getTag()});
        this.attachModalEntry(data, (cfg) => new EditorMultiText(cfg));
        return new MultiText(data);
    }

    protected replaceItems(items: any[]) {
        this.getTag().replaceItems(items);
    }

    protected getChoices() {
        return this.getTag().getChoices();
    }
}
